import { render, staticRenderFns } from "./fuxunPayResult.vue?vue&type=template&id=0e244eb9&scoped=true"
import script from "./fuxunPayResult.vue?vue&type=script&lang=js"
export * from "./fuxunPayResult.vue?vue&type=script&lang=js"
import style0 from "./fuxunPayResult.vue?vue&type=style&index=0&id=0e244eb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e244eb9",
  null
  
)

export default component.exports